<template>
  <section class="lpg-main">
    <Head title="Perfil"></Head>
    <div class="container-fluid px-0 mb-5">
      <div class="position-relative lpg-profile-cv">
        <div class="row g-0">
          <!-- left side -->
          <div class="col-12 col-md-4 col-lg-4 col-xl-3 px-4 pb-4 lpg-bg-green">
            <div class="d-flex justify-content-center align-items-center">
              <div class="d-flex flex-column">
                <div class="mt-5 mb-3 text-center d-block mx-auto">
                  <div class="profile-pic">
                    <img :src="company.logo_url" />
                  </div>
                </div>
                <div class="mb-4 text-center">
                  <h2 class="mt-2 lpg-form-title fs-4">{{ company.name }}</h2>
                </div>
              </div>
            </div>

            <div class="lpg-form lpg-form-box px-0">
              <section>
                <div
                  class="lpg-profile-content row row-cols-1 row-cols-md-1 gy-2 justify-content-center"
                >
                  <SidebarLinkItem
                    v-for="item in sidebar_filtered_items"
                    :key="item.key"
                    class="my-2"
                    :label="company[item.key]"
                    :icon="'bi bi-' + item.icon"
                    :url="company[item.key]"
                  >
                  </SidebarLinkItem>
                </div>
              </section>
            </div>
          </div>

          <!-- right side -->
          <div class="col-12 col-md col-lg text-start bg-white">
            <!-- Start header with image -->
            <div v-if="company.header_url" class="lpg-header position-relative d-none d-md-block">
              <img :src="company.header_url" class="img-fluid vw-100" alt="..." />
            </div>
            <!-- End header with image -->

            <div class="lpg-body-side-right">
              <div class="lpg-form lpg-form-box px-0">
                <div class="row mt-2">
                  <div class="col-12 text-center text-md-end">
                    <Link :href="$route('company.profile.edit')" class="btn btn-secondary mx-auto">
                      <BS-Icon
                        class="bi bi-pencil-square pe-3"
                        style="font-size: 1.5rem"
                        _label="edit icon"
                      />
                      Modificar información
                    </Link>
                  </div>
                </div>

                <section>
                  <h2 class="mt-5 lpg-form-title no-letter-spacing">Descripción</h2>

                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <p class="lpg-desc text-justify">
                        {{ company.description }}
                      </p>
                    </div>
                  </div>
                </section>

                <div class="row">
                  <div class="col-12 col-lg-6">
                    <section v-if="company.company_mission">
                      <h2 class="mt-5 lpg-form-title no-letter-spacing">Misión</h2>

                      <div class="lpg-profile-content">
                        <div class="card lpg-card lpg-card-white p-0 mb-3">
                          <p class="lpg-desc text-justify">
                            {{ company.company_mission }}
                          </p>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="col-12 col-lg-6">
                    <section v-if="company.company_vision">
                      <h2 class="mt-5 lpg-form-title no-letter-spacing">Visión</h2>

                      <div class="lpg-profile-content">
                        <div class="card lpg-card lpg-card-white p-0 mb-3">
                          <p class="lpg-desc text-justify">
                            {{ company.company_vision }}
                          </p>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>

                <section v-if="company.company_values">
                  <h2 class="mt-5 lpg-form-title no-letter-spacing">Valores</h2>

                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <p class="lpg-desc text-justify">
                        {{ company.company_values }}
                      </p>
                    </div>
                  </div>
                </section>
                <!-- <section>
                  <h2 class="mt-5 lpg-form-title no-letter-spacing">Tamaño de empresa</h2>

                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <p class="lpg-desc text-justify">
                        {{}}
                      </p>
                    </div>
                  </div>
                </section> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas'
import SidebarLinkItem from '@/Components/SidebarLinkItem'
import Icon from '@/Components/BS-Icon'

export default {
  name: 'EmpresaPerfil',
  layout: LayoutEmpresas,
  components: { Head, Link, SidebarLinkItem, Icon },
  props: {
    company: Object,
  },
  data() {
    return {
      sidebar_items: [
        {
          icon: 'globe',
          key: 'website_url',
        },
        {
          icon: 'facebook',
          key: 'fb_url',
        },
        {
          icon: 'instagram',
          key: 'ig_url',
        },
        {
          icon: 'linkedin',
          key: 'linkedin_url',
        },
      ],
    }
  },
  computed: {
    sidebar_filtered_items() {
      return this.sidebar_items.filter(item => this.company[item.key] !== null)
    },
  },
}
</script>

<style lang="scss" scoped>
.profile-pic {
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  width: 300px;
  height: 300px;
  border: solid grey 5px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
</style>
